import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

export default {
  extends: Form,
  data() {
    return {
      rule: [],
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20251124000000005',
    };
  },
  methods: {
    setRule(item) {
      const v = item;
      if (v.field === 'unit') {
        item.props = {
          ...item.props,
          filterable: true,
          remoteParams: 'dictValue',
        };
      }
      return v;
    },

    formComplete() {
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        request.post('/tpm/tpmactmaterial/query', { id: this.formConfig.row.id }).then((res) => {
          if (res.success) {
            const { result } = res;
            setTimeout(() => {
              this.setValue(result);
            }, 100);
          }
        });
      }
    },

    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/tpm/tpmactmaterial/save';
        // 有id  就是编辑
        if (this.formConfig.row.id) {
          formData.id = this.formConfig.row.id;
          url = '/tpm/tpmactmaterial/update';
        }
        delete formData.title1;
        request.post(url, formData).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
